import _ from "lodash";

const toggleSelection = (key, selection = [], onSelect) =>
  onSelect(_.xor(selection, [key.replace("select-", "")]));

export default toggleSelection;
